<template>
  <v-dialog :retain-focus="false" :value="sectionEditor.show" :width="1000" @input="handleClosePopup">
    <div style="background-color: #fff">
      <div class="header-modal">
        <v-card-title class="d-flex justify-space-between align-center" style="padding: 10px 0">
          <span style="color: #0081c7">{{ fields.title }}</span>
          <v-btn icon @click="handleClosePopup">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
      </div>
      <v-card-text style="max-height: 70vh; overflow-y: auto">
        <div class="mb-4">
          <label class="label-input">Section</label>
          <v-row>
            <v-col cols="12" md="8">
              <v-text-field v-model="fields.title" label="Name" />
            </v-col>
            <v-col cols="12" md="4">
              <v-checkbox v-model="fields.enableAnchor" label="Enable Anchor" />
            </v-col>
          </v-row>
        </div>

        <div class="mb-4">
          <label class="label-input">Style</label>
          <div class="group-item">
            <v-row>
              <v-col cols="12" md="6">
                <ColorPicker v-model="fields.background" name="background" label="Background" default-color="#ffffff" />
              </v-col>
              <v-col cols="12" md="6">
                <ColorPicker v-model="fields.textColor" name="text-color" label="Text Color" default-color="#000000" />
              </v-col>
              <v-col cols="12" md="4">
                <v-checkbox class="mt-0" v-model="fields.topPadding" label="Top Padding" hide-details />
              </v-col>
              <v-col cols="12" md="4">
                <v-checkbox class="mt-0" v-model="fields.bottomPadding" label="Bottom Padding" hide-details />
              </v-col>
              <v-col cols="12" md="4">
                <v-checkbox class="mt-0" v-model="fields.leftCard.centerY" label="Center Y" hide-details />
              </v-col>
              <v-col cols="12">
                <v-switch v-model="fields.enableContainerPage" label="Enable container page" hide-details />
              </v-col>
              <v-col cols="12" v-if="fields.enableContainerPage">
                <ColorPicker
                  v-model="fields.backgroundContainer"
                  name="background-container"
                  label="Container Background"
                  default-color="#ffffff"
                />
              </v-col>
            </v-row>
          </div>
        </div>

        <div class="mb-4">
          <label class="label-input">Title Card</label>
          <div class="group-item">
            <v-checkbox v-model="fields.showTitle" label="Show title" hide-details class="mt-0 mb-2" />
            <ckeditor :editor="editor" v-model="fields.titleCard" :config="editorConfig" />
          </div>
        </div>

        <div class="mb-5">
          <div class="d-flex justify-space-between align-center">
            <div class="d-flex align-center" style="gap: 10px">
              <label class="label-input mb-0">Box List</label>
              <input type="checkbox" v-model="fields.boxListItem.show" />
            </div>
            <v-btn small text color="primary" @click="handleAddBoxItem">
              <v-icon size="16">mdi-plus</v-icon>
              <span>Add Item</span>
            </v-btn>
          </div>
          <div class="group-item">
            <v-row>
              <v-col cols="12" md="6">
                <ColorPicker
                  v-model="fields.boxListItem.background"
                  name="box-background"
                  label="Box Background"
                  default-color="#ffffff33"
                />
              </v-col>
              <v-col cols="12" md="6">
                <ColorPicker
                  v-model="fields.boxListItem.color"
                  name="box-color"
                  label="Box Text Color"
                  default-color="#ffffff"
                />
              </v-col>
            </v-row>
            <v-expansion-panels accordion class="mt-2">
              <v-expansion-panel v-for="(item, index) in fields.boxListItem.listItem" :key="`box-item-${index}`">
                <v-expansion-panel-header>
                  <div class="d-flex justify-space-between align-center">
                    <span>Item {{ index + 1 }}</span>
                    <v-btn icon @click.stop="handleRemoveBoxItem(index)">
                      <v-icon size="18" color="#ff6c6c">mdi-delete</v-icon>
                    </v-btn>
                  </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <div class="mb-3">
                    <label class="mb-2 d-block">Icon</label>
                    <UploadImage
                      @callback="obj => handleUploadBoxIcon(obj, index)"
                      :image="{ imageSrc: item.iconItem || '' }"
                      :height="`140`"
                      :typeUpload="'image'"
                      @callbackDelete="() => handleRemoveBoxIcon(index)"
                    />
                  </div>
                  <div class="mb-3">
                    <label class="mb-2 d-block">Head</label>
                    <ckeditor :editor="editor" v-model="item.head" :config="editorConfig" />
                  </div>
                  <div>
                    <label class="mb-2 d-block">Content</label>
                    <ckeditor :editor="editor" v-model="item.content" :config="editorConfig" />
                  </div>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </div>
        </div>

        <div class="mb-5">
          <div class="d-flex justify-space-between align-center">
            <div class="d-flex align-center" style="gap: 10px">
              <label class="label-input mb-0">Pill List</label>
              <input type="checkbox" v-model="fields.pillListItem.show" />
            </div>
            <v-btn small text color="primary" @click="handleAddPillItem">
              <v-icon size="16">mdi-plus</v-icon>
              <span>Add Pill</span>
            </v-btn>
          </div>
          <div class="group-item">
            <v-row>
              <v-col cols="12" md="6">
                <ColorPicker
                  v-model="fields.pillListItem.background"
                  name="pill-background"
                  label="Pill Background"
                  default-color="#ffffff"
                />
              </v-col>
              <v-col cols="12" md="6">
                <ColorPicker
                  v-model="fields.pillListItem.color"
                  name="pill-color"
                  label="Pill Text Color"
                  default-color="#000000"
                />
              </v-col>
            </v-row>
            <v-expansion-panels accordion class="mt-2">
              <v-expansion-panel v-for="(item, index) in fields.pillListItem.listItem" :key="`pill-item-${index}`">
                <v-expansion-panel-header>
                  <div class="d-flex justify-space-between align-center">
                    <span>Pill {{ index + 1 }}</span>
                    <v-btn icon @click.stop="handleRemovePillItem(index)">
                      <v-icon size="18" color="#ff6c6c">mdi-delete</v-icon>
                    </v-btn>
                  </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <div class="mb-3">
                    <label class="mb-2 d-block">Icon</label>
                    <UploadImage
                      @callback="obj => handleUploadPillIcon(obj, index)"
                      :image="{ imageSrc: item.iconItem || '' }"
                      :height="`140`"
                      :typeUpload="'image'"
                      @callbackDelete="() => handleRemovePillIcon(index)"
                    />
                  </div>
                  <label class="mb-2 d-block">Text</label>
                  <ckeditor :editor="editor" v-model="item.text" :config="editorConfig" />
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </div>
        </div>

        <div class="mb-4">
          <label class="label-input">Right Card Media</label>
          <div class="group-item">
            <v-row>
              <v-col cols="12" md="6">
                <v-select
                  :value="Number(fields.rightCard.order) === 1 ? 1 : 2"
                  :items="positionOptions"
                  label="Right Card Position"
                  @change="handleChangePosition"
                />
              </v-col>
              <v-col cols="12" md="6">
                <v-radio-group
                  row
                  :value="fields.rightCard.mediaType || 'video'"
                  @change="handleChangeRightCardMediaType"
                >
                  <v-radio label="Image" value="image" />
                  <v-radio label="Video" value="video" />
                </v-radio-group>
              </v-col>
            </v-row>
            <div v-if="fields.rightCard.mediaType === 'image'">
              <UploadImage
                @callback="handleUploadRightCardImage"
                :image="{ imageSrc: fields.rightCard.image }"
                :height="`220`"
                :typeUpload="'image'"
                @callbackDelete="handleRemoveRightCardImage"
              />
            </div>
            <div v-else>
              <v-text-field :value="fields.rightCard.video" label="Video URL" @input="handleChangeRightCardVideo" />
              <div class="video-preview">
                <video v-if="fields.rightCard.video" width="100%" height="auto" autoplay muted loop playsinline>
                  <source :src="fields.rightCard.video" type="video/mp4" />
                </video>
              </div>
            </div>
          </div>
        </div>

        <div class="mb-4">
          <label class="label-input">Decor Bottom</label>
          <div class="group-item">
            <v-row>
              <v-col cols="12" md="4">
                <v-checkbox v-model="fields.decorBottomShow" label="Show decor bottom" hide-details class="mt-0" />
              </v-col>
              <v-col cols="12" md="4">
                <ColorPicker
                  v-model="fields.decorBottomColor"
                  name="decor-bottom-color"
                  label="Decor bottom color"
                  default-color="#ffffff"
                />
              </v-col>
            </v-row>
          </div>
        </div>
      </v-card-text>
      <div class="footer-modal">
        <v-card-actions style="padding: 10px 0">
          <v-spacer></v-spacer>
          <v-btn min-width="100" depressed @click="handleClosePopup">Cancel</v-btn>
          <v-btn min-width="100" color="primary" @click="handleSave">Save</v-btn>
        </v-card-actions>
      </div>
    </div>
  </v-dialog>
</template>

<script>
import Editor from 'ckeditor5-custom-build/build/ckeditor';
import { ckeditorConfigFullToolbar } from '@/helpers/editor';
import UploadImage from '@/components/form/uploadFile/UpdateImage.vue';
import { updateHtmlFromData } from '@/views/website/products/components/description/common/html/update';
import ColorPicker from './common/color-picker.vue';

export default {
  name: 'card-multi-tool-yuri-section-editor',
  components: {
    UploadImage,
    ColorPicker,
  },
  props: {
    sectionEditor: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      editor: Editor,
      editorConfig: ckeditorConfigFullToolbar,
      positionOptions: [
        { text: 'Left', value: 1 },
        { text: 'Right', value: 2 },
      ],
      fields: {
        title: 'Card Multi Tool Yuri Section',
        enableAnchor: false,
        topPadding: true,
        bottomPadding: true,
        background: '#FFFFFF',
        textColor: '#000000',
        enableContainerPage: false,
        backgroundContainer: '#FFFFFF',
        leftCard: { order: '1', centerY: false },
        rightCard: { order: '2', mediaType: 'video', image: '', video: '' },
        showTitle: true,
        titleCard: '<h2>Why Women Choose</h2><p></p>',
        boxListItem: { show: true, background: '#ffffff33', color: '#ffffff', listItem: [] },
        pillListItem: { show: true, background: '#ffffff', color: '#000000', listItem: [] },
        decorBottomShow: true,
        decorBottomColor: '#ffffff',
      },
    };
  },
  mounted() {
    this.fields = {
      ...this.fields,
      ...this.sectionEditor.sectionExtract,
      leftCard: {
        ...this.fields.leftCard,
        ...(this.sectionEditor.sectionExtract?.leftCard || {}),
      },
      rightCard: {
        ...this.fields.rightCard,
        ...(this.sectionEditor.sectionExtract?.rightCard || {}),
      },
      boxListItem: {
        ...this.fields.boxListItem,
        ...(this.sectionEditor.sectionExtract?.boxListItem || {}),
      },
      pillListItem: {
        ...this.fields.pillListItem,
        ...(this.sectionEditor.sectionExtract?.pillListItem || {}),
      },
    };

    this.fields.boxListItem.listItem = Array.isArray(this.fields.boxListItem.listItem)
      ? this.fields.boxListItem.listItem.map(item => ({
          iconItem: item.iconItem || '',
          head: item.head || '',
          content: item.content || '',
        }))
      : [];
    this.fields.pillListItem.listItem = Array.isArray(this.fields.pillListItem.listItem)
      ? this.fields.pillListItem.listItem
      : [];

    this.fields.rightCard.mediaType = this.fields.rightCard.mediaType === 'image' ? 'image' : 'video';
    if (this.fields.rightCard.mediaType === 'image') {
      this.fields.rightCard.video = '';
    } else {
      this.fields.rightCard.image = '';
    }
  },
  methods: {
    handleClosePopup() {
      this.$emit('close');
    },
    handleSave() {
      const payload = {
        ...this.fields,
        rightCard: {
          ...this.fields.rightCard,
          mediaType: this.fields.rightCard.mediaType === 'image' ? 'image' : 'video',
          image: this.fields.rightCard.mediaType === 'image' ? this.fields.rightCard.image || '' : '',
          video: this.fields.rightCard.mediaType === 'video' ? this.fields.rightCard.video || '' : '',
        },
        boxListItem: {
          ...this.fields.boxListItem,
          listItem: (this.fields.boxListItem.listItem || []).map(item => ({
            iconItem: item.iconItem || '',
            head: item.head || '',
            content: item.content || '',
          })),
        },
        pillListItem: {
          ...this.fields.pillListItem,
          listItem: (this.fields.pillListItem.listItem || []).map(item => ({
            iconItem: item.iconItem || '',
            text: item.text || '',
          })),
        },
      };

      const updateHtml = updateHtmlFromData.sectionCardMultiToolYuri(this.sectionEditor.section.html, payload);
      this.$emit('update:section', {
        ...this.sectionEditor.section,
        title: this.fields.title,
        html: updateHtml,
      });
      this.$emit('close');
    },
    handleChangePosition(value) {
      if (value === 1) {
        this.fields.rightCard.order = '1';
        this.fields.leftCard.order = '2';
      } else {
        this.fields.rightCard.order = '2';
        this.fields.leftCard.order = '1';
      }
    },
    handleChangeRightCardMediaType(value) {
      this.fields.rightCard.mediaType = value === 'image' ? 'image' : 'video';
      if (this.fields.rightCard.mediaType === 'image') {
        this.fields.rightCard.video = '';
      } else {
        this.fields.rightCard.image = '';
      }
    },
    handleUploadRightCardImage(obj) {
      this.fields.rightCard.mediaType = 'image';
      this.fields.rightCard.image = obj.imageSrc;
      this.fields.rightCard.video = '';
    },
    handleRemoveRightCardImage() {
      this.fields.rightCard.image = '';
    },
    handleChangeRightCardVideo(value) {
      this.fields.rightCard.mediaType = 'video';
      this.fields.rightCard.video = value || '';
      this.fields.rightCard.image = '';
    },
    handleAddBoxItem() {
      this.fields.boxListItem.listItem.push({
        iconItem: '',
        head: '<p>60-Day Money Back Guarantee</p>',
        content: '<p>Collagen Extract helps improve elasticity and resilience.</p>',
      });
    },
    handleUploadBoxIcon(obj, index) {
      if (!this.fields.boxListItem.listItem[index]) return;
      this.$set(this.fields.boxListItem.listItem[index], 'iconItem', obj.imageSrc || '');
    },
    handleRemoveBoxIcon(index) {
      if (!this.fields.boxListItem.listItem[index]) return;
      this.$set(this.fields.boxListItem.listItem[index], 'iconItem', '');
    },
    handleRemoveBoxItem(index) {
      this.fields.boxListItem.listItem.splice(index, 1);
    },
    handleAddPillItem() {
      this.fields.pillListItem.listItem.push({
        iconItem: '',
        text: '<p>Restores Elasticity</p>',
      });
    },
    handleUploadPillIcon(obj, index) {
      if (!this.fields.pillListItem.listItem[index]) return;
      this.$set(this.fields.pillListItem.listItem[index], 'iconItem', obj.imageSrc || '');
    },
    handleRemovePillIcon(index) {
      if (!this.fields.pillListItem.listItem[index]) return;
      this.$set(this.fields.pillListItem.listItem[index], 'iconItem', '');
    },
    handleRemovePillItem(index) {
      this.fields.pillListItem.listItem.splice(index, 1);
    },
  },
};
</script>

<style scoped lang="scss">
.group-item {
  padding: 15px 10px;
  border-radius: 10px;
  border: 1px solid #e0e0e0;
}
.label-input {
  font-size: 18px !important;
  font-weight: 500;
  color: #000;
  margin-bottom: 10px;
  display: block;
}
.header-modal {
  position: sticky;
  top: 0;
  left: 0;
  z-index: 999;
  background-color: #fff;
  padding: 0 16px;
  box-shadow: 0px 0px 12px #0000000f;
}
.footer-modal {
  position: sticky;
  padding: 0 16px;
  bottom: 0;
  left: 0;
  z-index: 999;
  background-color: #fff;
  box-shadow: 0px 0px 12px #0000000f;
}
.video-preview video {
  max-height: 240px;
  border-radius: 8px;
  background: #000;
}
</style>
